import { gql } from '@apollo/client'

const BASE_PRODUCT_FIELDS = gql`
  fragment BaseProductFields on StripeProductType {
    id
    name
    status
    duration
    price
    type
    isExtension
    isSubscription
    description
    originalPrice
    image
  }
`

export const FIND_ALL_PRODUCT = gql`
  query findAllProduct($query: ProductQueryInput!, $withHidden: Boolean) {
    findAllProduct(query: $query, withHidden: $withHidden) {
      items {
        id
        stripeProductId
        name
        status
        duration
        platform {
          id
          title
        }
        price
        active
        type
        isExtension
        isSubscription
        deletedAt
      }
      count
    }
  }
`

export const UPDATE_PRODUCT = gql`
  ${BASE_PRODUCT_FIELDS}
  mutation updateProduct($stripeProductInput: StripeProductInput!) {
    updateProduct(stripeProductInput: $stripeProductInput) {
      ...BaseProductFields
    }
  }
`

export const GET_PRODUCT = gql`
  ${BASE_PRODUCT_FIELDS}
  query getProduct($platformName: PlatformName!, $productId: String!) {
    getProduct(platofrmName: $platformName, productId: $productId) {
      ...BaseProductFields
    }
  }
`

export const CREATE_PRODUCT = gql`
  mutation createProduct($createProductInput: CreateProductInput!) {
    createProduct(createProductInput: $createProductInput) {
      id
      stripeProductId
      name
      status
      duration
      price
      type
      isExtension
      isSubscription
    }
  }
`

export const REMOVE_PRODUCT = gql`
  mutation removeProduct($productId: String!) {
    removeProduct(productId: $productId) {
      affected
    }
  }
`
